import { useSelector } from "react-redux";

export const useAgentData = () => useSelector(({ agent }) => agent);
